import React from "react";
import Select from "react-select";

const SchoolSelect = ({ onChange, options, defaultValue }) => {
  // Styles for the search and select
  const customStyles = {
    input: (provided, state) => ({
      ...provided,
    }),
    option: (provided, state) => ({
      ...provided,
      borderBottom: "1px solid black",
      padding: 15,
    }),
    control: (provided, state) => ({
      ...provided,
      border: "1px solid black",
      // match with the menu
      borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
      // Overwrittes the different states of border
      borderColor: "white",
      "&:hover": {
        // Overwrittes the different states of border
        borderColor: "#b6de3a",
      },
    }),
    singleValue: (provided, state) => ({
      ...provided,
      opacity: 0.9,
      padding: 15,
    }),
  };

  function handleChange(selectedOption) {
    if (onChange) {
      onChange(selectedOption);
    }
  }

  return (
    <div className="school-select">
      <Select
        styles={customStyles}
        options={options}
        onChange={(selectedOption) => handleChange(selectedOption.value)}
        value={options.find((item) => item.label === defaultValue)}
      />
    </div>
  );
};

export default SchoolSelect;
